
import styled from "styled-components"
import { Link } from "react-router-dom"

const StyledGreenCard = styled.div`
    background-color: rgba(183, 227, 56, 0.3);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 227px;
`;
const StyledWrapper = styled.div`
   padding: 10px;
`;
export function LevelResultsChild({ children, to, style }) {
    return (
        <StyledWrapper className="grid-card">
            <Link to={to} style={style}>
                <StyledGreenCard>
                    {children}
                </StyledGreenCard>
            </Link>
        </StyledWrapper>
    );
}
